import React from "react";
import {
  Badge,
  Box,
  Card,
  CardBody,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { formatInteger, formatPercent } from "../networkReportFormatters";

const STATUSES = [
  { key: "completed", label: "Completed", colorScheme: "green" },
  { key: "inProgress", label: "In progress", colorScheme: "blue" },
  { key: "notStarted", label: "Not started", colorScheme: "gray" },
  { key: "noSurvey", label: "No survey", colorScheme: "red" },
];

const NetworkOrganizationStatusSummary = ({
  statusCounts = {},
  averageCompletionRate,
}) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const itemBg = useColorModeValue("gray.50", "gray.700");
  const mutedColor = useColorModeValue("gray.600", "gray.400");

  return (
    <Card bg={cardBg} borderWidth="1px" borderColor={borderColor}>
      <CardBody>
        <Stack
          direction={{ base: "column", md: "row" }}
          align={{ base: "stretch", md: "start" }}
          justify="space-between"
          spacing={4}
        >
          <Box>
            <Heading size="sm">School survey status</Heading>
            <Text mt={1} color={mutedColor} fontSize="sm">
              Current survey status across schools in this network.
            </Text>
          </Box>
          <Box minW={{ md: "190px" }}>
            <Text color={mutedColor} fontSize="sm">
              Average school completion rate
            </Text>
            <Text fontSize="2xl" fontWeight="semibold">
              {formatPercent(averageCompletionRate)}
            </Text>
          </Box>
        </Stack>

        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={3} mt={5}>
          {STATUSES.map((status) => (
            <Box
              key={status.key}
              bg={itemBg}
              borderWidth="1px"
              borderColor={borderColor}
              borderRadius="md"
              p={3}
            >
              <Badge colorScheme={status.colorScheme}>{status.label}</Badge>
              <Text mt={2} fontSize="2xl" fontWeight="semibold">
                {formatInteger(
                  statusCounts[status.key] === undefined
                    ? 0
                    : statusCounts[status.key]
                )}
              </Text>
              <Text color={mutedColor} fontSize="sm">schools</Text>
            </Box>
          ))}
        </SimpleGrid>
      </CardBody>
    </Card>
  );
};

export default NetworkOrganizationStatusSummary;
